import React, { useContext, useState } from "react"
import { app, auth, db } from "../firebase"
import {
    onAuthStateChanged,
    sendEmailVerification,
    sendPasswordResetEmail,
    signInWithEmailAndPassword,
    signOut,
    updateEmail,
    updatePassword
} from "@firebase/auth"
import { getFunctions, httpsCallable } from "firebase/functions";
import { getUserInfo } from "../services/UserService";
import { doc, getDoc } from "firebase/firestore";
import {returnAuthBool} from "../components/CONSTANTS";

const AuthContext = React.createContext();
const UserContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function useUser() {
    return useContext(UserContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)
    const [trulyAuthenticated, setTrulyAuthenticated] = useState(true)
    const [userInfo, setUserInfo] = useState()

    const functions = getFunctions(app, "europe-west3");

    const addUser = httpsCallable(functions, "register")
    const createUserFromSuperAdmin = httpsCallable(functions, "createUserFromSuperAdmin")


    async function addUserFromSuperAdmin(email, password, firstname, lastname, authentication, company) {



        let tempAuth = returnAuthBool(authentication)


        const data = {
            email: email,
            password: password,
            firstName: firstname,
            lastName: lastname,
            allowWeb: tempAuth,
            company: company
        }



        await createUserFromSuperAdmin(data).then((res, fail) => {
            if (res) {
                return res.toString()

            }

            if (fail) {
                return "Misslyckat försök"
            }


        }).catch(() => {
            console.error()
        })
    }



    async function signup(email, password, firstname, lastname, authentication, company) {



        let tempAuth = returnAuthBool(authentication)


        const data = {
            email: email,
            password: password,
            firstName: firstname,
            lastName: lastname,
            allowWeb: tempAuth,
            company: company
        }



        await addUser(data).then((res, fail) => {
            if (res) {
                return res.toString()

            }

            if (fail) {
                return "Misslyckat försök"
            }


        }).catch(() => {
            console.error()
        })
    }

    async function login(email, password) {


        setTrulyAuthenticated(false)

        await signInWithEmailAndPassword(auth, email, password)
        const uid = auth.currentUser.uid

        const uInfo = await getUserInfo(uid)
        setUserInfo(uInfo)


        if (uInfo?.allowWeb) {
            
            setTrulyAuthenticated(true)

            return true
        } else {
            return false;
        }


    }


    const getCompanyValues = async (name) => {

        const docRef = doc(db, "Company", name)
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data()
        }
    }

    function logout() {
        return signOut(auth)
    }

    function resetPassword(email) {
        return sendPasswordResetEmail(auth, email)
    }

    async function handleupdateEmail(email) {
        return updateEmail(currentUser, email)
    }


    function handleUpdatePassword(password) {
        return updatePassword(currentUser, password).catch(() => console.error)
    }

    async function handleEmailVerification() {
        await sendEmailVerification(auth.currentUser)
    }


    onAuthStateChanged(auth, async user => {
        setCurrentUser(user)
        setLoading(false)

    })

    const value = {
        trulyAuthenticated,
        currentUser,
        userInfo,
        login,
        logout,
        resetPassword,
        handleUpdatePassword,
        getCompanyValues,
        signup,
        returnAuthBool,
        handleEmailVerification

    }


    return (
        <AuthContext.Provider value={value}>

            {!loading && children}
        </AuthContext.Provider>
    )
}
